import { getHoffmanEnvironment } from '../services/windowService';

const { GA_MEASUREMENT_ID = '', GA_DEBUG_MODE = '' } = getHoffmanEnvironment();
/* Category's code from Tag Commander that allows to enable GA */
const TAG_COMMANDER_CATEGORY_ID_FOR_GA = '1';

export const googleAnalyticsConfig = {
  gaMeasurementId: GA_MEASUREMENT_ID,
  tagCommanderCategoryForGa: TAG_COMMANDER_CATEGORY_ID_FOR_GA,
  debugMode: GA_DEBUG_MODE,
};
